import Vue from 'vue';
import Component from 'vue-class-component';
import {ProductViewport, PartProductOverviewport, Viewport} from '../../models/Viewport';
import {Language, ProductVersion} from '../../models/ProductModels';
import {getVersionUrl} from '../../models/UtilService';
import { version } from 'punycode';

@Component({
    props:{
        viewport:{
            
        }
    }
})
export default class SoftbookVersionSelectDropdown extends Vue{
    
    hrefValue:string="";
    viewport;
    versionTitle:string="";
    
    versionChanged(){
      //  window.location.href=this.hrefValue;
      if(this.viewport.spaceProperty.spaceType==='SERVICE_PACK')
      {
        this.$router.push({path:'/'+this.$i18n.locale+'/servicepack/'+this.hrefValue});
      }
      else{
          this.$router.push({path:'/'+this.$i18n.locale+'/product/'+this.hrefValue});
      }
     // this.$router.push({path:'/'});

    }

    
    getVersURL(version: ProductVersion):string{
        return getVersionUrl(version, this.viewport);
    }


    getVersURLForProdversion(productVersion: ProductVersion, lang: Language, prodName: string):string{
        return productVersion.spaceUrl
    }


    getVersionTitle():string{
        return this.versionTitle;
    }

    concatProdNameAndVersion(prodName:string, version:string):string
    {
        return prodName+' '+version;
    }

    created(){
       // console.log("VERSION SELECT SOFTBOOKS ", (<ProductViewport>this.viewport).currentVersion);
        let version:ProductVersion =(<ProductViewport>this.viewport).currentVersion;
       
      //  console.dir("Inside Softbook dowpdown = ", version);


        //Check if Viewport is for a Service Pack then retrieve viewport.spaceProperty.name instead of .prod
        if(this.viewport.spaceProperty.spaceType === "SERVICE_PACK" ){
            this.versionTitle = this.viewport.spaceProperty.servicePackName;
        }
        else{            
            this.versionTitle = this.concatProdNameAndVersion(this.viewport.spaceProperty.prod,version.version);
        }

        if(!this.versionTitle)
        {
            throw('Fatal Error. No product version found');
        }

        this.hrefValue = this.getVersURL(version); 
    }
}
